import ArticleInnerPage from './article-inner-page';
export default ArticleInnerPage; 